import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  questionResultAdd(dto) {
    return this.http.post(`https://seedtecmapi.eksx.com/mapi/temp/test_questionResultAdd.php`, dto);
  }

  gameResultAdd(dto) {
    return this.http.post(`https://seedtecmapi.eksx.com/mapi/temp/test_gameResultAdd.php`, dto);
  }

  gameStart(dto) {
    return this.http.post(`https://seedtecmapi.eksx.com/mapi/temp/test_gameStart.php`, dto);
  }
}
